import React from 'react'
import { Control, Controller, FieldValues } from 'react-hook-form'

import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select, { SelectProps } from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from '@material-ui/core/FormHelperText'

interface Props {
  label?: string
  options: { label: string; value: string | number }[]
  control: Control<FieldValues> | any
  name: string
  onChangeAction?: (value: any) => void
  helperText?: React.ReactNode
}
const SelectInput = ({
  label,
  name,
  defaultValue,
  control,
  onChangeAction,
  options,
  helperText,
  ...rest
}: Props & SelectProps) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? ''}
      render={({ onChange }) => (
        <FormControl variant="outlined" size="small" fullWidth>
          <InputLabel>{label}</InputLabel>
          <Select
            {...rest}
            onChange={({ target }) => {
              onChange(target.value)
              if (onChangeAction) onChange(target.value)
            }}
            label={label}
            defaultValue={defaultValue}
          >
            {options.map((option, index) => (
              <MenuItem value={option.value} key={index}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{helperText}</FormHelperText>
        </FormControl>
      )}
    />
  )
}

export default SelectInput
